<nz-form-item [formGroup]="formGroup()">
	<nz-form-label [nzSpan]="labelSpan()" [nzRequired]="required()">
		{{ label() }}
	</nz-form-label>

	<nz-form-control [nzSpan]="controlSpan()" nzHasFeedback [nzErrorTip]="errorTpl">
		<input
			nz-input
			type="text"
			[formControlName]="controlName()"
			[placeholder]="placeholder()"
			[min]="min()"
			[max]="max()"
			appDecimalOnly
		/>
	</nz-form-control>
</nz-form-item>

<ng-template #errorTpl let-control>
	@if (control.errors?.['required']) {
		This field is required
	}
	@if (control.errors?.['min']) {
		Must be at least {{ control.errors['min'].min }}
	}
	@if (control.errors?.['max']) {
		Must be at most {{ control.errors['max'].max }}
	}
</ng-template>
